import { Link } from "react-router-dom";
import "./ServicesTeaser.css";

function ServicesTeaser({
  title, text,
  subTitle1, eyebrow1, subText1,
  subTitle2, eyebrow2, subText2,
  subTitle3, eyebrow3, subText3,
  subTitle4, eyebrow4, subText4,
  ctaButtonText
}) {
  return (
    <section className="services-teaser-container">
      <div className="services-teaser-inner hover-lift">

        <div className="services-teaser-header">
          <h2>{title}</h2>
          <p>{text}</p>
          <Link to="/services" className="btn services-teaser-cta-btn">
            {ctaButtonText}
          </Link>
        </div>

        <div className="services-teaser-grid">
          <div className="service-card hover-lift">
            <span className="service-tag">{eyebrow1}</span>
            <h3>{subTitle1}</h3>
            <p>{subText1}</p>
          </div>

          <div className="service-card hover-lift">
            <span className="service-tag">{eyebrow2}</span>
            <h3>{subTitle2}</h3>
            <p>{subText2}</p>
          </div>

          <div className="service-card hover-lift">
            <span className="service-tag">{eyebrow3}</span>
            <h3>{subTitle3}</h3>
            <p>{subText3}</p>
          </div>

          <div className="service-card hover-lift">
            <span className="service-tag">{eyebrow4}</span>
            <h3>{subTitle4}</h3>
            <p>{subText4}</p>
          </div>
        </div>

      </div>
    </section>
  );
}

export default ServicesTeaser;
